import ApiClient from './base-api-client';

const v1ApiClient = new ApiClient({ baseURL: '/v1/' });

export default v1ApiClient;
